/**
 * 출처에서 받은 텍스트 정제.
 *
 * **이건 이 제품의 존재 이유에 걸린 문제다.** 우리는 남의 데이터를 정제해서
 * 다시 내보내는 서비스인데, 정제 결과가 원문보다 지저분하면 존재 가치가 없다.
 * 실측에서 `&apos;` 가 986회, 제목 144건·요약 1,674건에 그대로 나갔다.
 *
 * 정제는 **수집 시점에 한 번** 한다. 렌더 시점에 하면 소비처마다 각자
 * `.replace(/&nbsp;/g, ' ')` 를 붙이게 되고, 실제로 그렇게 돼 있었다 — 목록은
 * `&nbsp;` 만 처리하고 `&apos;` 는 놓쳤다. 사이트맵·OG·RSS 처럼 조용한
 * 소비처는 아예 손도 안 댔다.
 */
/** 정부 공고에서 실제로 관측된 엔티티. 없는 것을 상상해서 넣지 않는다. */
const NAMED = {
    nbsp: ' ',
    amp: '&',
    lt: '<',
    gt: '>',
    quot: '"',
    apos: "'",
    ensp: ' ',
    emsp: ' ',
    thinsp: ' ',
    middot: '·',
    hellip: '…',
    ndash: '–',
    mdash: '—',
    lsquo: '‘',
    rsquo: '’',
    ldquo: '“',
    rdquo: '”',
};
/**
 * 엔티티를 **한 번만** 푼다.
 *
 * 반복해서 풀면 안 된다. 원문에 `&amp;lt;` 가 있으면 그건 "＆lt;" 라는 글자를
 * 뜻하므로 `&lt;` 까지가 정답이다. 한 번 더 풀면 `<` 가 되고, 그다음 태그
 * 제거에 먹혀 글자가 사라진다.
 */
export function decodeEntitiesOnce(text) {
    return text.replace(/&(#x?[0-9a-fA-F]+|[a-zA-Z]+);/g, (whole, body) => {
        if (body.startsWith('#')) {
            const code = body[1] === 'x' || body[1] === 'X'
                ? Number.parseInt(body.slice(2), 16)
                : Number.parseInt(body.slice(1), 10);
            // 제어문자로는 풀지 않는다 — 눈에 안 보이는 쓰레기가 본문에 박힌다.
            if (!Number.isFinite(code) || code < 32 || code > 0x10ffff)
                return whole;
            return String.fromCodePoint(code);
        }
        return NAMED[body.toLowerCase()] ?? whole;
    });
}
/**
 * HTML 태그. `<` 바로 뒤에 영문자(`<p>`)·슬래시(`</p>`)·느낌표(`<!--`)가
 * 오는 것만이다.
 *
 * `<[^>]+>` 로 두면 꺾쇠로 감싼 제목이 통째로 지워진다. 실측: K-Startup
 * 178629 의 제목 `<2026 로컬 스타트업 챌린지, 의정부 2026>` 이 빈 문자열이
 * 되어 스키마에서 버려졌다. 공고 제목에서 꺾쇠는 강조 부호지 마크업이 아니다.
 */
const HTML_TAG = /<(?:[a-zA-Z!/])[^>]{0,400}>/g;
/**
 * 출처 텍스트 한 줄기를 사람이 읽을 형태로.
 *
 * 순서가 중요하다: **태그를 먼저 지우고 엔티티를 푼다.** 반대로 하면 원문의
 * `&lt;p&gt;` 가 `<p>` 로 풀렸다가 태그로 오인되어 지워진다.
 *
 * 정제 후 아무것도 안 남으면 null 이다. `&nbsp;` 하나뿐인 요약이 실제로
 * 있는데, 공백 한 칸을 요약이라고 부를 수는 없다.
 */
export function cleanSourceText(text) {
    if (text === null || text === undefined)
        return null;
    const out = decodeEntitiesOnce(text.replace(HTML_TAG, ' '))
        .replace(/\s+/g, ' ')
        .trim();
    return out === '' ? null : out;
}
//# sourceMappingURL=text.js.map